// extracted by mini-css-extract-plugin
export default {"breadcrumbsRow":"Pq-z","breadcrumbForward":"Qq-z","breadcrumbBack":"Rq-z","selected":"Sq-z"};